// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC_1-buNYgFUYxOCH_o8I_KBExbZcFkc6w",
  authDomain: "todxb-key.firebaseapp.com",
  projectId: "todxb-key",
  storageBucket: "todxb-key.firebasestorage.app",
  messagingSenderId: "341794420502",
  appId: "1:341794420502:web:d5f61a94e57b9c67acc237",
  measurementId: "G-3S7QJ0WP8F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Initialize Analytics only if supported and in browser environment
let analytics: ReturnType<typeof getAnalytics> | null = null;
if (typeof window !== 'undefined') {
  isSupported().then((yes) => {
    if (yes) {
      analytics = getAnalytics(app);
    }
  }).catch(() => {
    // Analytics not available, continue without it
  });
}

export { app, analytics, db };
